import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'

const BulletList = styled.ul`
  margin: 0;
  padding-inline-start: ${rem(21)};
`

function LoyaltyBurnInfoModal() {
  const intl = useIntl()
  const { resolve } = useModalElementContext()

  const title = intl.formatMessage(
    {
      id: 'wVagL7Tih2S5zQSmufVO',
      defaultMessage: 'Using your {programName} Points',
    },
    { programName: getLoyaltyProgramDisplayName() },
  )

  return <Modal
    title={title}
    onClose={() => resolve()}
  >
    <Group gap={20} direction="vertical">
      <BodyText variant="medium" colour="light-foreground-alt">
        <FormattedMessage
          id="2FiXDPdzjtZx6ctYTX4O"
          defaultMessage="{programName} Points are earned on every booking you make with us — the more you travel, the more you accumulate. When you're ready to use them, they come straight off the price of your next escape."
          
          values={{ programName: getLoyaltyProgramDisplayName() }}
        />
      </BodyText>
      <BulletList>
        <li>
          <BodyText variant="medium" colour="light-foreground-alt">
            <FormattedMessage
              id="6cbxdDOv-Rgu0glv6O-G"
              defaultMessage="You need at least 1,000 points to start redeeming"
              
            />
          </BodyText>
        </li>
        <li>
          <BodyText variant="medium" colour="light-foreground-alt">
            <FormattedMessage
              id="pFcJ1MIWG4tNyN9L-gUA"
              defaultMessage="Use all your points, or mix them with cash — it's up to you"
              
            />
          </BodyText>
        </li>
        <li>
          <BodyText variant="medium" colour="light-foreground-alt">
            <FormattedMessage
              id="Y5Pz1xaPw5Uy5BJ2vGKc"
              defaultMessage="At checkout, use the slider to choose exactly how many points to apply"
              
            />
          </BodyText>
        </li>
        <li>
          <BodyText variant="medium" colour="light-foreground-alt">
            <FormattedMessage
              id="5BPvqdQH_9H2xa2ZFPtF"
              defaultMessage="Points can be used across hotels, tours, cruises, flights and more"
              
            />
          </BodyText>
        </li>
      </BulletList>
    </Group>
  </Modal>
}

export default LoyaltyBurnInfoModal
